module.exports = __webpack_public_path__ + "img/woori-crowd-online-seller.b1335718.png";